import { __awaiter } from "tslib";
import { ALL_SINGLE_RENDER_METHODS, OVD_EVENT_TO_SECTIONS_MAP } from "./renderSectionsMap";
import { calculateTeusFromSlots, createRowsFromConfig, } from "@tedivo/tedivo-bay-grid-pure";
import { BayLevelEnum, } from "open-vessel-definition";
import BaysSection from "../parts/bay-boxes/bays-section";
import { createSimpleAlert, mapDataToDictionary, } from "@tedivo/tedivo-ui";
import ViewCgsConfig from "../config/ViewCgsConfig";
import { getTranslation, i18n } from "../../../../app/i18/i18tn";
import ovdJsonStore from "../../../../app/stores/OVDJsonStore";
import CellSpacingEnum from "../../../../app/enums/CellSpacingEnum";
import GroupBaysPairedEnum from "../../../../app/enums/GroupBaysPairedEnum";
import SizeSmallMidLargeEnum from "../../../../app/enums/SizeSmallMidLargeEnum";
import ViewShipDataConfig from "../config/ViewShipDataConfig";
import ViewSizeSummaryConfig from "../config/ViewSizeSummaryConfig";
import { createDeckView } from "./createDeckView";
import { createPart } from "./createPart";
import { createSideView } from "./createSideView";
import { getPreferencesValue } from "@tedivo/tedivo-preferences";
import getTranslatedDictionary from "../../../../app/i18/getTranslatedDictionary";
import { pad3 } from "@tedivo/tedivo-pure-helpers";
import { removeChildren } from "@tedivo/tedivo-dom-helpers";
export default class ViewJsonRender {
    get node() {
        return this.mainNode;
    }
    set viewD3ClearColor(color) {
        if (!this.rendererForShip)
            return;
        this.rendererForShip.colorMode = color;
    }
    get bayGroupedDisplay() {
        return this.bayDrawOptions.baysPairedGrouped;
    }
    set bayGroupedDisplay(value) {
        if (this.bayDrawOptions.baysPairedGrouped !== value)
            this.bayDrawOptions.baysPairedGrouped = value;
        this.nodes.baySection.bayBoxes.setAttribute("data-group-paired-bays", String(value === GroupBaysPairedEnum.GROUPED));
    }
    get fit2Vertical() {
        return this.bayDrawOptions.fit2Vertical;
    }
    set fit2Vertical(value) {
        var _a;
        if (this.bayDrawOptions.fit2Vertical !== value)
            this.bayDrawOptions.fit2Vertical = value;
        (_a = this.baysSection) === null || _a === void 0 ? void 0 : _a.calcAndSetScale(value);
    }
    constructor(props, containersWithPositions) {
        this.context = {};
        this.rendererForShip = undefined;
        this.renderGeneral = () => {
            const json = this.props.json;
            if (!json)
                return;
            this.nodes.general.withLoading(() => __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const shipNameAkas = (((_b = (_a = ovdJsonStore.tvdId) === null || _a === void 0 ? void 0 : _a.shipNameAkaStr) === null || _b === void 0 ? void 0 : _b.split("|")) || []).filter((s) => s && s !== json.shipData.shipName);
                const viewShipData = Object.assign(Object.assign({}, json.shipData), { shipNameAkas: shipNameAkas.length ? shipNameAkas : undefined });
                const shipPartDataElements = getTranslatedDictionary(mapDataToDictionary(viewShipData, ViewShipDataConfig, i18n.language));
                const partConfig = {
                    name: "shipData",
                    title: "view:shipDataTitle",
                    elements: shipPartDataElements,
                    editAction: (_c = this.context.buttonsAndActions) === null || _c === void 0 ? void 0 : _c.editGeneralButton,
                };
                const htmlOutput = createPart(partConfig.name, partConfig.title, partConfig.elements, partConfig.editAction);
                removeChildren(this.nodes.general);
                this.nodes.general.dataset.lastUpdated = new Date().toISOString();
                this.nodes.general.appendChild(htmlOutput);
            }));
        };
        this.renderSizeSummary = () => {
            const json = this.props.json;
            if (!json)
                return;
            this.nodes.sizeSummary.withLoading(() => __awaiter(this, void 0, void 0, function* () {
                var _a;
                const sizeSummaryDataElements = getTranslatedDictionary(mapDataToDictionary(Object.assign(Object.assign({}, json.sizeSummary), { totalTEUs: this.context.totalTEUs || 0 }), ViewSizeSummaryConfig, i18n.language));
                const partConfig = {
                    name: "sizeSummary",
                    title: "view:sizeSummaryTitle",
                    elements: sizeSummaryDataElements,
                    editAction: (_a = this.context.buttonsAndActions) === null || _a === void 0 ? void 0 : _a.editSizeSummaryButton,
                };
                const htmlOutput = createPart(partConfig.name, partConfig.title, partConfig.elements, partConfig.editAction);
                removeChildren(this.nodes.sizeSummary);
                this.nodes.sizeSummary.dataset.lastUpdated = new Date().toISOString();
                this.nodes.sizeSummary.appendChild(htmlOutput);
            }));
        };
        this.renderCenterOfGravity = () => {
            var _a;
            const json = this.props.json;
            const cgsStats = (_a = this.props.lcgVcgTcgAndPairings) === null || _a === void 0 ? void 0 : _a.cgStats;
            if (!json || !cgsStats)
                return;
            this.nodes.centersOfGravity.withLoading(() => __awaiter(this, void 0, void 0, function* () {
                var _a;
                const cgsPartData = {
                    lcgValues: json.shipData.lcgOptions.values,
                    vcgValues: json.shipData.vcgOptions.values,
                    tcgValues: json.shipData.tcgOptions.values,
                    lcgDataFilled: Math.floor((cgsStats.definedLcgs / (cgsStats.countLcgs || 1)) * 100),
                    vcgDataFilled: Math.floor((cgsStats.definedBottomBase / (cgsStats.countBottomBase || 1)) * 100),
                    tcgDataFilled: Math.floor((cgsStats.definedTcgs / (cgsStats.countTcgs || 1)) * 100),
                    lpp: json.shipData.lcgOptions.lpp,
                    loa: json.shipData.loa || 0,
                    sternToAftPp: json.shipData.sternToAftPp || 0,
                };
                const cgsPartDataElements = getTranslatedDictionary(mapDataToDictionary(cgsPartData, ViewCgsConfig, i18n.language));
                {
                    // Anomalies in CGs? Show button and dialog
                    const cgsValidatorResult = ovdJsonStore.ovdValidator.getLastResultByName("cgsValidator");
                    const cgsSumry = cgsValidatorResult === null || cgsValidatorResult === void 0 ? void 0 : cgsValidatorResult.result.summary.outOfBounds;
                    const anomaliesButton = showCGsAnomaliesButton(cgsSumry);
                    if (anomaliesButton) {
                        cgsPartDataElements.push({
                            label: getTranslation("view:cgs.validationWarning"),
                            value: anomaliesButton,
                            type: "HtmlElement",
                        });
                    }
                }
                const partConfig = {
                    name: "cgsSummary",
                    title: "view:cgsDataTitle",
                    elements: cgsPartDataElements,
                    disabled: !this.props.canOpenDrawer,
                    editAction: (_a = this.context.buttonsAndActions) === null || _a === void 0 ? void 0 : _a.editCGsButton,
                };
                const htmlOutput = createPart(partConfig.name, partConfig.title, partConfig.elements, partConfig.editAction);
                removeChildren(this.nodes.centersOfGravity);
                this.nodes.centersOfGravity.dataset.lastUpdated = new Date().toISOString();
                this.nodes.centersOfGravity.appendChild(htmlOutput);
            }));
        };
        this.renderD3View = () => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const json = this.props.json;
            const lcgVcgTcgAndPairings = this.props.lcgVcgTcgAndPairings;
            const containersWithPositions = this.context.containersWithPositions;
            if (!json ||
                !lcgVcgTcgAndPairings ||
                lcgVcgTcgAndPairings.cgStats.totalSlotsCount < 10 ||
                !containersWithPositions)
                return;
            if (!this.rendererForShip) {
                import(/* webpackChunkName: "create3DView", webpackPrefetch: true */ "./create3DView").then((module) => {
                    var _a, _b, _c;
                    const { container, renderer } = module.create3DView({
                        shipData: json.shipData,
                        sizeSummary: json.sizeSummary,
                        baysData: json.baysData,
                        vesselPartsData: json.vesselPartsData || [],
                        lcgVcgTcgAndPairings,
                        offsetBottomBases: (_b = (_a = ovdJsonStore.currentJson) === null || _a === void 0 ? void 0 : _a.shipData.masterCGs) === null || _b === void 0 ? void 0 : _b.offsetBottomBases,
                        v3DParams: (_c = ovdJsonStore.tvdId) === null || _c === void 0 ? void 0 : _c.v3DParams,
                        colorMode: this.props.colorMode,
                        containersWithPositions,
                        onLoadedCb,
                    });
                    this.rendererForShip = renderer;
                    const { card, chkMouseWheelZoom } = create3DCardNodes(this.rendererForShip, undefined, //this.context.buttonsAndActions?.editView3DActions,
                    this.nodes.d3View.baysSelector);
                    card.appendChild(container);
                    chkMouseWheelZoom.checked = false;
                    renderer.mouseWheelZoom = false;
                    removeChildren(this.nodes.d3View.holder);
                    this.nodes.d3View.holder.dataset.lastUpdated = new Date().toISOString();
                    this.nodes.d3View.holder.appendChild(card);
                    renderer.onWindowResize();
                    renderer.shouldAnimate = 3000;
                    renderer.animate();
                    setTimeout(() => {
                        renderer.resetView3DInShip();
                    }, 3000);
                    function onLoadedCb() {
                        card.isLoading = false;
                    }
                });
            }
            else {
                this.rendererForShip.reInit({
                    shipData: json.shipData,
                    sizeSummary: json.sizeSummary,
                    baysData: json.baysData,
                    vesselPartsData: json.vesselPartsData || [],
                    lcgVcgTcgAndPairings,
                    offsetBottomBases: (_b = (_a = ovdJsonStore.currentJson) === null || _a === void 0 ? void 0 : _a.shipData.masterCGs) === null || _b === void 0 ? void 0 : _b.offsetBottomBases,
                    v3DParams: (_c = ovdJsonStore.tvdId) === null || _c === void 0 ? void 0 : _c.v3DParams,
                    containersWithPositions,
                });
                createBaysSelectListOptions(this.nodes.d3View.baysSelector);
            }
            function createBaysSelectListOptions(selectContainers) {
                const prevValue = selectContainers.value;
                const options = [
                    {
                        value: "all",
                        text: getTranslation("view:view3D.view3DActions.allBays"),
                    },
                    ...((lcgVcgTcgAndPairings === null || lcgVcgTcgAndPairings === void 0 ? void 0 : lcgVcgTcgAndPairings.blockBaysAndSizes.filter((bs) => bs.definedSlots > 0).map((bs) => bs.allBays)) || []).map((allBays) => {
                        const baysN = allBays.split("-").map(Number);
                        const allOk = baysN.every((n) => !isNaN(n));
                        const label = baysN.length === 1 || !allOk
                            ? allBays
                            : `${allBays} (${pad3((baysN[0] + baysN[1]) * 0.5)})`;
                        return {
                            value: allBays,
                            text: getTranslation("view:view3D.view3DActions.bay", {
                                bay: label,
                            }),
                        };
                    }),
                ];
                removeChildren(selectContainers);
                options.forEach((option) => {
                    const selectOption = document.createElement("sl-option");
                    selectOption.value = option.value;
                    selectOption.innerHTML = option.text;
                    selectContainers.appendChild(selectOption);
                });
                if (prevValue) {
                    selectContainers.value = prevValue;
                }
            }
            function create3DCardNodes(rendererForShip, editView3DActions, selectContainers) {
                // Action Box
                const view3DActionBox = document.createElement("div");
                view3DActionBox.style.display = "flex";
                view3DActionBox.style.gap = "1em";
                view3DActionBox.style.alignItems = "baseline";
                // Reset View Button
                const reset3DViewButton = document.createElement("sl-button");
                reset3DViewButton.size = "small";
                reset3DViewButton.pill = true;
                reset3DViewButton.innerHTML = getTranslation("view:view3D.view3DActions.reset");
                reset3DViewButton.addEventListener("click", () => {
                    rendererForShip === null || rendererForShip === void 0 ? void 0 : rendererForShip.resetView3DInShip();
                });
                const tooltipBaySelector = document.createElement("sl-tooltip");
                tooltipBaySelector.content = getTranslation("view:view3D.view3DActions.baySelector");
                tooltipBaySelector.placement = "left-start";
                createBaysSelectListOptions(selectContainers);
                selectContainers.size = "small";
                selectContainers.value = "all";
                selectContainers.addEventListener("sl-change", () => {
                    rendererForShip === null || rendererForShip === void 0 ? void 0 : rendererForShip.setContainerVisibility(selectContainers.value);
                });
                tooltipBaySelector.appendChild(selectContainers);
                // Activate toggle Button
                const chkMouseWheelZoom = document.createElement("sl-switch");
                chkMouseWheelZoom.size = "small";
                chkMouseWheelZoom.innerHTML = getTranslation("view:view3D.view3DActions.mouseWheelZoom");
                chkMouseWheelZoom.className = "btn-activate-3d";
                chkMouseWheelZoom.setAttribute("part", "part-activate-3d");
                chkMouseWheelZoom.addEventListener("sl-change", () => {
                    if (!rendererForShip)
                        return;
                    rendererForShip.mouseWheelZoom = chkMouseWheelZoom.checked;
                });
                view3DActionBox.appendChild(tooltipBaySelector);
                view3DActionBox.appendChild(chkMouseWheelZoom);
                view3DActionBox.appendChild(reset3DViewButton);
                // Edit Button
                if (editView3DActions)
                    view3DActionBox.appendChild(editView3DActions);
                // Card of 3D View
                const card = document.createElement("card-element");
                card.titleHtml = "view:3dView.title";
                card.className = "card-3d-view";
                card.name = "3dView";
                card.isLoading = true;
                card.actions = view3DActionBox;
                return {
                    card,
                    chkMouseWheelZoom,
                };
            }
        });
        this.render = (json, event, lcgVcgTcgAndPairings) => {
            var _a;
            if (!json || !lcgVcgTcgAndPairings) {
                console.warn("No data to render");
                return;
            }
            // 1. Update context
            this.context.totalTEUs = calculateTeusFromSlots(json.baysData);
            this.context.buttonsAndActions = this.props.createEditButtonsAndActions(lcgVcgTcgAndPairings);
            // 2. Select render methods
            const type = (_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.type;
            const renderMethods = type
                ? OVD_EVENT_TO_SECTIONS_MAP[type] || ALL_SINGLE_RENDER_METHODS
                : ALL_SINGLE_RENDER_METHODS;
            // 3. Render
            renderMethods.forEach((method) => this[method](event === null || event === void 0 ? void 0 : event.detail));
        };
        this.props = props;
        this.context.containersWithPositions = containersWithPositions;
        this.bayDrawOptions = getBayDrawPreferences();
        this.mainNode = document.createElement("div");
        this.nodes = this.buildHtml(this.mainNode);
        this.bayGroupedDisplay = this.bayDrawOptions.baysPairedGrouped;
        this.fit2Vertical = this.bayDrawOptions.fit2Vertical;
        this.render(props.json, undefined, props.lcgVcgTcgAndPairings);
    }
    updateData({ event, json, lcgVcgTcgAndPairings, containersWithPositions, }) {
        if (!json || !lcgVcgTcgAndPairings) {
            console.warn("No data to render");
            return;
        }
        // 1. Update data
        this.props.json = json;
        this.props.lcgVcgTcgAndPairings = lcgVcgTcgAndPairings;
        this.context.containersWithPositions = containersWithPositions;
        this.render(json, event, lcgVcgTcgAndPairings);
    }
    /** Updates the size and spacing options and redraws all the bays */
    updateDrawPreferences(size, cellSpacing, newBayGrouped, fit2Vertical) {
        if (size !== undefined)
            this.bayDrawOptions.cellSize = size;
        if (cellSpacing !== undefined)
            this.bayDrawOptions.cellSpacing = cellSpacing;
        if (newBayGrouped !== undefined)
            this.bayGroupedDisplay = newBayGrouped;
        if (fit2Vertical !== undefined)
            this.fit2Vertical = fit2Vertical;
        this.renderBays();
    }
    renderSideView() {
        var _a;
        const json = this.props.json;
        const lcgVcgTcgAndPairings = this.props.lcgVcgTcgAndPairings;
        const containersWithPositions = this.context.containersWithPositions;
        const sideViewNode = this.nodes.sideView;
        if (!json || !lcgVcgTcgAndPairings || !containersWithPositions)
            return;
        const tooltip = document.createElement("sl-tooltip");
        tooltip.content = getTranslation("view:sideView.displayConts.tooltip");
        tooltip.placement = "left-start";
        const selectContainers = document.createElement("sl-select");
        selectContainers.size = "small";
        const options = [
            {
                value: "maxSize",
                text: getTranslation("view:sideView.displayConts.maxSize"),
            },
            {
                value: "stbdOuter",
                text: getTranslation("view:sideView.displayConts.stbdOuter"),
            },
            {
                value: "portOuter",
                text: getTranslation("view:sideView.displayConts.portOuter"),
            },
            { value: "all", text: getTranslation("view:sideView.displayConts.all") },
            ...createRowsFromConfig(!!json.sizeSummary.centerLineRow, json.sizeSummary.maxRow).map((row) => ({
                value: row,
                text: getTranslation("view:rowNumber", { row }),
            })),
        ];
        options.forEach((option) => {
            const selectOption = document.createElement("sl-option");
            selectOption.value = option.value;
            selectOption.innerHTML = option.text;
            selectContainers.appendChild(selectOption);
        });
        selectContainers.value = "maxSize";
        selectContainers.addEventListener("sl-change", () => {
            renderSideViewInternal(json, lcgVcgTcgAndPairings, containersWithPositions, sideViewNode, actionsDiv);
        });
        tooltip.appendChild(selectContainers);
        const actionsDiv = document.createElement("div");
        actionsDiv.style.display = "flex";
        actionsDiv.style.gap = "0.5em";
        actionsDiv.appendChild(tooltip);
        if ((_a = this.context.buttonsAndActions) === null || _a === void 0 ? void 0 : _a.editSideViewActions)
            actionsDiv.appendChild(this.context.buttonsAndActions.editSideViewActions);
        renderSideViewInternal(json, lcgVcgTcgAndPairings, containersWithPositions, sideViewNode, actionsDiv);
        function renderSideViewInternal(json, lcgVcgTcgAndPairings, containersWithPositions, sideViewNode, actionsDiv) {
            sideViewNode.withLoading(() => __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const htmlOutput = yield createSideView({
                    sizeSummary: json.sizeSummary,
                    baysData: json.baysData,
                    vesselPartsData: json.vesselPartsData || [],
                    v3DParams: (_a = ovdJsonStore.tvdId) === null || _a === void 0 ? void 0 : _a.v3DParams,
                    offsetBottomBases: (_c = (_b = ovdJsonStore.currentJson) === null || _b === void 0 ? void 0 : _b.shipData.masterCGs) === null || _c === void 0 ? void 0 : _c.offsetBottomBases,
                    lcgVcgTcgAndPairings,
                    containersWithPositions,
                    editActionNode: actionsDiv,
                    selectContainerCriteria: selectContainers.value,
                    bayNumbersDoubleClickAction: doubleClickOnSvgBay,
                });
                if (selectContainers.value === "portOuter") {
                    const svg = htmlOutput.querySelector("svg");
                    if (svg) {
                        svg.style.transform = "scaleX(-1)";
                    }
                    const topNumbers = htmlOutput.querySelectorAll(".top-bay-number");
                    topNumbers.forEach((el) => {
                        if (el) {
                            el.style.transform = "scaleX(-1)";
                            el.setAttribute("x", String(-Number(el.getAttribute("x"))));
                        }
                    });
                }
                removeChildren(sideViewNode);
                sideViewNode.dataset.lastUpdated = new Date().toISOString();
                sideViewNode.appendChild(htmlOutput);
            }));
        }
    }
    renderDeckView() {
        var _a;
        const json = this.props.json;
        const lcgVcgTcgAndPairings = this.props.lcgVcgTcgAndPairings;
        const containersWithPositions = this.context.containersWithPositions;
        const deckViewNode = this.nodes.deckView;
        if (!json || !lcgVcgTcgAndPairings || !containersWithPositions)
            return;
        // const tooltip = document.createElement("sl-tooltip");
        // tooltip.content = getTranslation("view:sideView.displayConts.tooltip");
        // tooltip.placement = "left-start";
        // const selectContainers = document.createElement("sl-select");
        // selectContainers.size = "small";
        // const options = [
        //   {
        //     value: "highestBelowOrLowestAbove",
        //     text: getTranslation(
        //       "view:deckView.displayConts.highestBelowOrLowestAbove",
        //     ),
        //   },
        //   {
        //     value: "highestAll",
        //     text: getTranslation("view:deckView.displayConts.highestAll"),
        //   },
        //   {
        //     value: "highestBelow",
        //     text: getTranslation("view:deckView.displayConts.highestBelow"),
        //   },
        // ];
        // options.forEach((option) => {
        //   const selectOption = document.createElement("sl-option");
        //   selectOption.value = option.value;
        //   selectOption.innerHTML = option.text;
        //   selectContainers.appendChild(selectOption);
        // });
        // selectContainers.value = "highestBelowOrLowestAbove";
        // selectContainers.style.width = "260px";
        // selectContainers.addEventListener("sl-change", () => {
        //   renderDeckViewInternal(
        //     json,
        //     lcgVcgTcgAndPairings,
        //     containersWithPositions,
        //     deckViewNode,
        //     actionsDiv,
        //   );
        // });
        // tooltip.appendChild(selectContainers);
        const actionsDiv = document.createElement("div");
        actionsDiv.style.display = "flex";
        actionsDiv.style.gap = "0.5em";
        // actionsDiv.appendChild(tooltip);
        if ((_a = this.context.buttonsAndActions) === null || _a === void 0 ? void 0 : _a.editDeckViewActions) {
            actionsDiv.appendChild(this.context.buttonsAndActions.editDeckViewActions);
        }
        renderDeckViewInternal(json, lcgVcgTcgAndPairings, containersWithPositions, deckViewNode, actionsDiv);
        function renderDeckViewInternal(json, lcgVcgTcgAndPairings, containersWithPositions, deckViewNode, actionsDiv) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a;
                const htmlOutput = yield createDeckView({
                    sizeSummary: json.sizeSummary,
                    masterCGs: json.shipData.masterCGs,
                    baysData: json.baysData,
                    lidData: json.lidData,
                    vesselPartsData: json.vesselPartsData || [],
                    v3DParams: (_a = ovdJsonStore.tvdId) === null || _a === void 0 ? void 0 : _a.v3DParams,
                    lcgVcgTcgAndPairings,
                    containersWithPositions,
                    editActionNode: actionsDiv,
                    selectContainerCriteria: "highestBelow", //  selectContainers.value as IDeckSelectContainerCriteria,
                    bayNumbersDoubleClickAction: doubleClickOnSvgBay,
                });
                removeChildren(deckViewNode);
                deckViewNode.dataset.lastUpdated = new Date().toISOString();
                deckViewNode.appendChild(htmlOutput);
            });
        }
    }
    renderBays(eventDetail) {
        var _a, _b, _c;
        const bays = (_a = eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.data) === null || _a === void 0 ? void 0 : _a.map((bay) => bay.split("-")[0]);
        const btnsAndActions = this.context.buttonsAndActions;
        if (!btnsAndActions)
            return;
        if (!this.baysSection) {
            this.baysSection = new BaysSection({
                createEditBayButtonFunction: btnsAndActions.createEditBayButtonFunction,
                readonlyMode: this.props.readonlyMode,
                canOpenDrawer: this.props.canOpenDrawer,
                bayHelpersButton: btnsAndActions.bayHelpersButton,
                shipName: ((_b = this.props.json) === null || _b === void 0 ? void 0 : _b.shipData.shipName) || "",
            });
            (_c = this.baysSection) === null || _c === void 0 ? void 0 : _c.calcAndSetScale(this.bayDrawOptions.fit2Vertical);
            this.nodes.baySection.bayBoxes.appendChild(this.baysSection.mainNode);
        }
        this.baysSection.render({
            lcgVcgTcgAndPairings: this.props.lcgVcgTcgAndPairings,
            bayDrawOptions: this.bayDrawOptions,
            baysToRender: bays,
        });
    }
    buildHtml(mainNode) {
        const nodes = {
            general: document.createElement("div-spinner-element"),
            sizeSummary: document.createElement("div-spinner-element"),
            centersOfGravity: document.createElement("div-spinner-element"),
            sideView: document.createElement("div-spinner-element"),
            deckView: document.createElement("div-spinner-element"),
            d3View: {
                holder: document.createElement("div-spinner-element"),
                baysSelector: document.createElement("sl-select"),
            },
            baySection: {
                holder: document.createElement("div-spinner-element"),
                legend: document.createElement("div"),
                bayBoxes: document.createElement("div"),
            },
        };
        nodes.baySection.holder.appendChild(nodes.baySection.legend);
        nodes.baySection.holder.appendChild(nodes.baySection.bayBoxes);
        mainNode.appendChild(nodes.general);
        mainNode.appendChild(nodes.sizeSummary);
        mainNode.appendChild(nodes.centersOfGravity);
        mainNode.appendChild(nodes.sideView);
        mainNode.appendChild(nodes.d3View.holder);
        mainNode.appendChild(nodes.deckView);
        mainNode.appendChild(nodes.baySection.holder);
        return nodes;
    }
}
function doubleClickOnSvgBay(node) {
    const bay = node.dataset.bay;
    const el = document.getElementById(`bay-box-component-${bay}`);
    if (el)
        el.scrollIntoView({ block: "center", behavior: "auto" });
}
function getBayDrawPreferences() {
    const baySizeOption = getPreferencesValue("bay-data-size");
    const bayCellSeparationOption = getPreferencesValue("bay-cell-separation");
    const bayGroupedPairedOption = getPreferencesValue("bay-grouped-paired");
    const fit2Vertical = getPreferencesValue("bay-fit2-vertical");
    return {
        cellSize: baySizeOption !== null && baySizeOption !== void 0 ? baySizeOption : SizeSmallMidLargeEnum.SMALL,
        cellSpacing: bayCellSeparationOption !== null && bayCellSeparationOption !== void 0 ? bayCellSeparationOption : CellSpacingEnum.NO_SPACE,
        baysPairedGrouped: bayGroupedPairedOption !== null && bayGroupedPairedOption !== void 0 ? bayGroupedPairedOption : GroupBaysPairedEnum.NOT_GROUPED,
        fit2Vertical: fit2Vertical === true || fit2Vertical === "true",
    };
}
function showCGsAnomaliesButton(cgsSumry) {
    if (!cgsSumry)
        return undefined;
    if (!cgsSumry.lcgsMightBeOutOfRange &&
        !cgsSumry.loaIsLowerThanLpp &&
        !cgsSumry.loaMighBeOutOfRange &&
        !cgsSumry.lppMighBeOutOfRange &&
        cgsSumry.baysOutOfBounds.length === 0)
        return undefined;
    const anomaliesButton = document.createElement("sl-button");
    anomaliesButton.variant = "danger";
    anomaliesButton.innerHTML = getTranslation("view:cgs.seeAnomalies");
    anomaliesButton.size = "small";
    const dangerIcon = document.createElement("sl-icon");
    dangerIcon.name = "exclamation-diamond";
    dangerIcon.slot = "prefix";
    anomaliesButton.appendChild(dangerIcon);
    anomaliesButton.addEventListener("click", showCgsAnomaliesDetailsDialog);
    return anomaliesButton;
    function showCgsAnomaliesDetailsDialog() {
        if (!cgsSumry)
            return;
        const booleanProps = [
            "loaIsLowerThanLpp",
            "loaMighBeOutOfRange",
            "lppMighBeOutOfRange",
            "lcgsMightBeOutOfRange",
        ];
        const messages = [];
        booleanProps.forEach((prop) => {
            if (cgsSumry[prop])
                messages.push(`view:cgs.${prop}`);
        });
        const div = document.createElement("div");
        if (messages.length) {
            messages.forEach((m) => {
                const mNode = document.createElement("div");
                mNode.innerHTML = getTranslation(m) + ".";
                div.appendChild(mNode);
            });
        }
        if (cgsSumry.baysOutOfBounds.length) {
            const mNode = document.createElement("div");
            mNode.innerHTML = getTranslation("view:cgs.baysOutOfBounds") + ":";
            div.appendChild(mNode);
            const ul = document.createElement("ul");
            cgsSumry.baysOutOfBounds.forEach((i) => {
                const li = document.createElement("li");
                li.innerHTML = `${i.bay} 
          ${getTranslation(`enums:BayLevelEnum.${BayLevelEnum[i.level]}`)}
          ${i.size}ft: ${i.reasons
                    .map((r) => getTranslation(`view:cgs.ReasonCgsWrong.${r}`))
                    .join(", ")}
        `;
                ul.appendChild(li);
            });
            div.appendChild(ul);
        }
        createSimpleAlert({
            title: getTranslation("view:cgs.validationWarning"),
            message: div,
            closeLabel: getTranslation("general:common.ok"),
            width: "700px",
        });
    }
}
